import { Formik } from 'formik';
import React, { useContext, useEffect } from 'react';
import { BackButton } from '../../components/BackButton';
import { Checkbox } from '../../components/Checkbox';
import { Step } from '../../models/Step';
import { ApplicationFormStateContext } from '../../state/applicationFormState';
import { saveStateRemote } from '../../utils/api';
import { trackEvent } from '../../utils/gtm';
import { scrollToTopOfContent } from '../../utils/scroll';
import { useNavigate } from 'react-router-dom';


const CardsStep: React.FunctionComponent = () => {
  const [state, dispatch] = useContext(ApplicationFormStateContext);
  const navigate = useNavigate();
  const { creditCardsDinersClub, creditCardsMasterCard, creditCardsPetrol, creditCardsVisa, debitCardsMasterCard, dankort } = state;

  useEffect(() => {
    trackEvent({eventName: 'step_load', data: { step: 'Cards' } });
    dispatch({ type: 'set_step', step: Step.Cards });
    scrollToTopOfContent();

    const saveState = async () => {
      await saveStateRemote(state);
    };
    saveState();
  }, []);

  return (
    <>
      <h2>Betalingskort?</h2>

      <h3>Hvilke købe- og kreditkort har du?</h3>

      <Formik
        initialValues={{ creditCardsDinersClub, creditCardsMasterCard, creditCardsPetrol, creditCardsVisa, debitCardsMasterCard, dankort }}
        onSubmit={async (values) => {
          dispatch({ 
            type: 'set_cards', 
            creditCardsDinersClub: values.creditCardsDinersClub ?? false,
            creditCardsMasterCard: values.creditCardsMasterCard ?? false,
            creditCardsPetrol: values.creditCardsPetrol ?? false,
            creditCardsVisa: values.creditCardsVisa ?? false,
            debitCardsMasterCard: values.debitCardsMasterCard ?? false,
            dankort: values.dankort ?? false
          });
          navigate('/betaling');
        }}
      >
        {(formikProps) => (
          <div className="mt-5">
            <div>
              <Checkbox
                isStatic={true}
                heading="Dankort"
                checked={formikProps.values?.dankort ?? false}
                isInvalid={formikProps.values?.dankort !== undefined}
                onChange={(checked) => {
                  formikProps.setValues({
                    ...formikProps.values,
                    dankort: checked,
                  });
                }}
              >
                {(formikProps.touched.dankort || formikProps.submitCount > 0) &&
                  formikProps.errors.dankort && (
                    <div className="invalid-feedback">
                      {formikProps.errors.dankort}
                    </div>
                  )}
              </Checkbox>
            </div>

            <div className="mt-1">
              <Checkbox
                isStatic={true}
                heading="MasterCard debit"
                checked={formikProps.values?.debitCardsMasterCard ?? false}
                isInvalid={
                  formikProps.values?.debitCardsMasterCard !== undefined
                }
                onChange={(checked) => {
                  formikProps.setValues({
                    ...formikProps.values,
                    debitCardsMasterCard: checked,
                  });
                }}
              >
                {(formikProps.touched.debitCardsMasterCard ||
                  formikProps.submitCount > 0) &&
                  formikProps.errors.debitCardsMasterCard && (
                    <div className="invalid-feedback">
                      {formikProps.errors.debitCardsMasterCard}
                    </div>
                  )}
              </Checkbox>
            </div>

            <div className="mt-1">
              <Checkbox
                isStatic={true}
                heading="MasterCard"
                checked={formikProps.values?.creditCardsMasterCard ?? false}
                isInvalid={
                  formikProps.values?.creditCardsMasterCard !== undefined
                }
                onChange={(checked) => {
                  formikProps.setValues({
                    ...formikProps.values,
                    creditCardsMasterCard: checked,
                  });
                }}
              >
                {(formikProps.touched.creditCardsMasterCard ||
                  formikProps.submitCount > 0) &&
                  formikProps.errors.creditCardsMasterCard && (
                    <div className="invalid-feedback">
                      {formikProps.errors.creditCardsMasterCard}
                    </div>
                  )}
              </Checkbox>
            </div>

            <div className="mt-1">
              <Checkbox
                isStatic={true}
                heading="VISA"
                checked={formikProps.values?.creditCardsVisa ?? false}
                isInvalid={formikProps.values?.creditCardsVisa !== undefined}
                onChange={(checked) => {
                  formikProps.setValues({
                    ...formikProps.values,
                    creditCardsVisa: checked,
                  });
                }}
              >
                {(formikProps.touched.creditCardsVisa ||
                  formikProps.submitCount > 0) &&
                  formikProps.errors.creditCardsVisa && (
                    <div className="invalid-feedback">
                      {formikProps.errors.creditCardsVisa}
                    </div>
                  )}
              </Checkbox>
            </div>

            <div className="mt-1">
              <Checkbox
                isStatic={true}
                heading="Diners Club"
                checked={formikProps.values?.creditCardsDinersClub ?? false}
                isInvalid={
                  formikProps.values?.creditCardsDinersClub !== undefined
                }
                onChange={(checked) => {
                  formikProps.setValues({
                    ...formikProps.values,
                    creditCardsDinersClub: checked,
                  });
                }}
              >
                {(formikProps.touched.creditCardsDinersClub ||
                  formikProps.submitCount > 0) &&
                  formikProps.errors.creditCardsDinersClub && (
                    <div className="invalid-feedback">
                      {formikProps.errors.creditCardsDinersClub}
                    </div>
                  )}
              </Checkbox>
            </div>

            <div className="mt-1">
              <Checkbox
                isStatic={true}
                heading="Benzinkort"
                checked={formikProps.values?.creditCardsPetrol ?? false}
                isInvalid={formikProps.values?.creditCardsPetrol !== undefined}
                onChange={(checked) => {
                  formikProps.setValues({
                    ...formikProps.values,
                    creditCardsPetrol: checked,
                  });
                }}
              >
                {(formikProps.touched.creditCardsPetrol ||
                  formikProps.submitCount > 0) &&
                  formikProps.errors.creditCardsPetrol && (
                    <div className="invalid-feedback">
                      {formikProps.errors.creditCardsPetrol}
                    </div>
                  )}
              </Checkbox>
            </div>

            <div className="container-btn">
              <BackButton />
              <button
                className="btn-next"
                type="submit"
                onClick={() => formikProps.submitForm()}
              >
                Næste
              </button>
            </div>
          </div>
        )}
      </Formik>
    </>
  );
};

export default CardsStep;
